export enum CDLEndorsements {
  None = 0,
  // eslint-disable-next-line no-bitwise
  DTTrailers = 1 << 0,
  // eslint-disable-next-line no-bitwise
  Passenger = 1 << 1,
  // eslint-disable-next-line no-bitwise
  Tank = 1 << 2,
  // eslint-disable-next-line no-bitwise
  HazMat = 1 << 3,
  // eslint-disable-next-line no-bitwise
  TankAndHazMat = 1 << 4,
  // eslint-disable-next-line no-bitwise
  SchoolBus = 1 << 5
}
export const CDLEndorsementsMapping: Record<CDLEndorsements, string> = {
  [CDLEndorsements.None]: 'None',
  [CDLEndorsements.DTTrailers]: 'T - Double/Triple Trailers',
  [CDLEndorsements.Passenger]: 'P - Passenger',
  [CDLEndorsements.Tank]: 'N - Tank Vehicle',
  [CDLEndorsements.HazMat]: 'H - Haz Mat',
  [CDLEndorsements.TankAndHazMat]: 'X - Tank & Haz Mat',
  [CDLEndorsements.SchoolBus]: 'S - School Bus'
};

export const CDLEndorsementsAbbrMapping: Record<CDLEndorsements, string> = {
  [CDLEndorsements.None]: 'None',
  [CDLEndorsements.DTTrailers]: 'T',
  [CDLEndorsements.Passenger]: 'P',
  [CDLEndorsements.Tank]: 'N',
  [CDLEndorsements.HazMat]: 'H',
  [CDLEndorsements.TankAndHazMat]: 'X',
  [CDLEndorsements.SchoolBus]: 'S'
};
